import React, { useEffect, useState } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableFooter,
	TableHead,
	TableRow,
	Paper,
	Typography,
	Stack,
	TextField,
	Box,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";


import { pdf } from "@react-pdf/renderer";
import { ApiService } from "../../ApiService";
import { GeneratePdfOrdenVenta } from "./GeneratePdfOrdenVenta";
import LupaIcon from "../../../svg/lupaIcon";

import buscar_azul from "../../../images/search_azul.png";
import pdfIcon from "../../../images/pdf.png";
import { useParams } from "react-router-dom";
import { useCompanyAssigned } from "../../CompanyAssignedContext";
import TablesMobile from "../../empresa/TablesMobile";
import SearchCompany from "../../../pages/empresa_uno/SearchCompany";

export const VnotaVentas = ({ selectedSucursal, convertPrice = (() => { }) }) => {
	const { nit, sub_direc } = useParams();

	const [sucursales, setSucursales] = useState([]);
	const [objQNs, setObjQNs] = useState([]);
	const [fechaIni, setFechaIni] = useState(null);
	const [fechaFin, setFechaFin] = useState(null);

	const [pdfModalVisible, setPdfModalVisible] = useState(false);
	const [pdfApiResponse, setPdfApiResponse] = useState({});
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	// 1) Función para obtener las notas de venta
	const fetchQNs = async (key_branch, fecha1, fecha2) => {
		const url = `api/company/sale/notes?start_date=${fecha1}&end_date=${fecha2}&key_branch=${key_branch}`;
		const options = { method: "GET" };

		const request_totals = await ApiService.fetchData(url, options);
		if (!request_totals) {
			alert("Error al cargar las notas de venta");
			return;
		}
		setObjQNs(request_totals);
	};



	// 2) Efecto inicial
	useEffect(() => {
		const current_suc = selectedSucursal;
		const comp_date = new Date();
		const currentDate = `${comp_date.getFullYear()}-${String(comp_date.getMonth() + 1).padStart(2, "0")}-${String(comp_date.getDate()).padStart(2, "0")}`;

		if (fechaIni == null && fechaFin == null) {
			setFechaFin(currentDate);
			setFechaIni(currentDate);
		}
		setSucursales(selectedSucursal);
		fetchQNs(selectedSucursal, fechaIni || currentDate, fechaFin || currentDate);
		setSucursales(current_suc);
		fetchQNs(current_suc, fechaIni || currentDate, fechaFin || currentDate);
	}, [selectedSucursal]);

	// 3) Manejar cambio de fechas
	function handleChange(e, comp) {
		if (comp === 1) {
			setFechaIni(e);
			fetchQNs(sucursales, e, fechaFin);
		} else {
			setFechaFin(e);
			fetchQNs(sucursales, fechaIni, e);
		}
	}

	// 4) Función para generar y descargar el PDF al hacer clic en el ojo
	const handleViewOrder = async (note) => {
		try {
			const url = `api/company/sale/find/${note.authCode}?key_branch=${selectedSucursal}`;
			const options = { method: "GET" };
			const saleOrderData = await ApiService.fetchData(url, options);

			if (saleOrderData) {
				setPdfApiResponse(saleOrderData);
				setPdfModalVisible(true);
			} else {
				alert("No se encontró la información de la nota de venta.");
			}
		} catch (error) { }
	};

	// 5) Cálculo de total general
	const totalGeneral = objQNs?.reduce((acc, note) => (parseFloat(acc) + parseFloat(note.total_sale)).toFixed(2), 0);

	const onPdfModalClose = () => {
		setPdfModalVisible(false);
		setPdfApiResponse({});
	};

	const componentViewPDF = (nota) => {
		return (
			<button
				className="btn-view"
				style={{
					textDecoration: "none",
					color: "#fff",
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "5px 8px",
					backgroundColor: "var(--theme-company)",
					border: "none",
					borderRadius: "50%",
					cursor: "pointer",
				}}
				onClick={() => handleViewOrder(nota)}>
				<FontAwesomeIcon icon={faEye} style={{ color: "#fff", fontSize: "15px" }} />
			</button>
		)
	}

	const returnTotal = () => {
		return totalGeneral;
	}

	return (
		<div>
			<div className="functionality-container">
				<div className="header-reports">
					<h2 style={{ color: 'var(--theme-company)' }}>Nota de Ventas</h2>

					<div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
						<TextField
							label="Fecha Inicial"
							type="date"
							value={fechaIni}
							onChange={(e) => handleChange(e.target.value, 1)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>

						<TextField
							label="Fecha Fin"
							type="date"
							value={fechaFin}
							onChange={(e) => handleChange(e.target.value, 2)}
							size="small"
							sx={{ width: "150px" }}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</div>

					<div>
						<SearchCompany theme={'var(--theme-company)'} placeholder="nota de venta" />

						<div style={{ display: 'none' }}>
							<button className="btn-add-var">
								<img className="icon-down pdf-icon" src={pdfIcon} alt="pdf" />
								<span className="txt-add">PDF</span>
							</button>
						</div>
					</div>
				</div>
			</div>



			{
				currentSize > 480 ? (
					<div className="table-view-pc">
						<TableContainer component={Paper}>
							<Table>
								<TableHead>
									<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
										{["Fecha", "N.- Nota", "Cliente", "Cel. de CLIENTE", "Total", "Ver"].map(
											(header, index) => (
												<TableCell
													key={index}
													sx={{ color: "white", fontWeight: "bold", textAlign: "center" }}>
													{header}
												</TableCell>
											)
										)}
									</TableRow>
								</TableHead>

								<TableBody>
									{objQNs &&
										objQNs.map((note, idx) => (
											<TableRow key={idx}>
												<TableCell align="center">{note.date_sale}</TableCell>
												<TableCell align="center">{note.nro}</TableCell>
												<TableCell align="center">{note.client_name}</TableCell>
												<TableCell align="center">
													<Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
														<Typography>{note.phone}</Typography>
														<a
															href={`https://wa.me/${note.code_phone}${note.phone}`}
															target="_blank"
															rel="noopener noreferrer"
															style={{
																backgroundColor: "#25D366",
																borderRadius: "50%",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
																width: "24px",
																height: "24px",
																textDecoration: "none",
															}}>
															<WhatsAppIcon style={{ color: "white", fontSize: "18px" }} />
														</a>
													</Stack>
												</TableCell>
												<TableCell align="center">{convertPrice(note.total_sale, null, true)}</TableCell>
												<TableCell
													align="center"
													sx={{
														verticalAlign: "middle",
													}}>
													<button
														className="btn-view"
														style={{
															textDecoration: "none",
															color: "#fff",
															display: "inline-flex",
															alignItems: "center",
															justifyContent: "center",
															padding: "5px 8px",
															backgroundColor: "var(--theme-company)",
															border: "none",
															borderRadius: "50%",
															cursor: "pointer",
														}}
														onClick={() => handleViewOrder(note)}>
														<FontAwesomeIcon icon={faEye} style={{ color: "#fff", fontSize: "15px" }} />
													</button>
												</TableCell>
											</TableRow>
										))}
								</TableBody>

								<TableFooter>
									<TableRow sx={{ backgroundColor: 'var(--theme-company)' }}>
										<TableCell colSpan={3} align="center" sx={{ color: "white", fontWeight: "bold" }}>
											Total
										</TableCell>
										{/* Celda en blanco */}
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }}>
											{convertPrice(totalGeneral)}
										</TableCell>
										{/* Celda en blanco */}
										<TableCell align="center" sx={{ color: "white", fontWeight: "bold" }} />
									</TableRow>
								</TableFooter>
							</Table>
						</TableContainer>
					</div>
				) : (
					<TablesMobile filteredData={(objQNs ?? []).map(obj => ({
						img: obj?.img_product,
						title: obj?.client_name,
						texto: convertPrice(obj?.total_sale),
						other: obj?.date_sale,
						fullPhone: obj?.codePhone + obj?.phone,
						authCode: obj,
						code: obj?.codigo,
					}))} profile={false} mode="reportes" functionEspecial={componentViewPDF} facturado={null} returnTotal={returnTotal} />
				)
			}

			{
				pdfModalVisible && pdfApiResponse ? <GeneratePdfOrdenVenta isOpen={pdfModalVisible} themeColor={'var(--theme-company)'} apiResponse={pdfApiResponse} onClose={onPdfModalClose} convertPrice={convertPrice} /> : <></>
			}
		</div>
	);
};
